import { ButtonSizes } from 'types';
export const buttonTextSizeDecorator = (size?: ButtonSizes) => {
	switch (size) {
		case 'large':
			return 'p';
		case 'small':
			return 'small';
		case 'medium':
		default:
			return 'span';
	}
};
